module.exports = __webpack_public_path__ + "static/005-96e794f7af5faea23eb106e9d4200ec9.jpg";